<template lang="pug">
#BankAccount
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Bank Account" :HeaderGlobalBreadcrumb="breadcrumb")
    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading Bank Account Information
                .header-cta.flex.items-center
                    //- router-link.link-text(to="#") Visit account

        .box__body.p-4
            template(v-if="load_data_status_bank_account.status === 'loading'")
                Loading(show="true")
            template(v-else-if="bank_account && bank_account.data && bank_account.data.length > 0")
                .box--items.p-4.mb-4.rounded(v-for="cc in bank_account.data")
                    .flex.flex-wrap
                        .block.px-4(class="w-full lg:w-2/12")
                            .block.mb-4
                                span.block.mb-1 Name
                                router-link.link-text.block(:to="cc.nama ? '/search-by-name/'+ encrypt(cc.nama,'name') : '/search-by-name'" target="_blank")
                                    | {{cc.nama}}
                        .block.px-4(class="w-full lg:w-2/12")
                            .block.mb-4
                                span.block.mb-1 Address
                                p.text-light {{cc.alamat}}
                        .block.px-4(class="w-full lg:w-2/12")
                            .block.mb-4
                                span.block.mb-1 Bank Name
                                p.text-light {{cc.nama_bank}}
                        .block.px-4(class="w-full lg:w-2/12")
                            .block.mb-4
                                span.block.mb-1 Account Number
                                p.text-light {{cc.id_reg_bank}}
                        .block.px-4(class="w-full lg:w-2/12")
                            .block.mb-4
                                span.block.mb-1 Virtual Bank
                                p.text-light {{cc.id_virtual_bank}}
            NoDataAvailable(v-else)

    //- end

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { encrypt } from '@/util/crypto';

export default {
    name: 'BankAccount',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Bank Account',
                    url: '/result/bank-account',
                },
            ],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_bank_account',
            'bank_account',
        ]),
    },
    watch: {
        // 
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        encrypt(key, type) {
            return encrypt(key+ '&&' +type);
        },
    },
}
</script>

<style lang="sass">
</style>
